import { render, staticRenderFns } from "./TheContributorDrawer.vue?vue&type=template&id=bfbaf70e&"
import script from "./TheContributorDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheContributorDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports